module.exports = __webpack_public_path__ + "img/left-landingpage.be375091.png";